
import { computed, defineComponent, PropType } from 'vue'
import { UnavailableDaysDto } from 'service/__generated-api'

export default defineComponent({
  props: {
    unavailableDays: {
      type: Object as PropType<UnavailableDaysDto>
    }
  },
  setup(props) {
    const unpaidLeaveTooltipText =
      'Unpaid leave that you can take after exceeding the 30-day limit'

    const showCarryoverInfo = computed(
      () => (props.unavailableDays?.paid.carriedOver ?? 0) > 0
    )

    const headers = {
      acceptedPaid: { header: 'Accepted Paid Leave', tooltip: '' },
      plannedPaid: { header: 'Planned Paid Leave', tooltip: '' },
      acceptedUnpaid: {
        header: 'Accepted Unpaid Leave',
        tooltip: unpaidLeaveTooltipText
      },
      plannedUnpaid: {
        header: 'Planned Unpaid Leave',
        tooltip: unpaidLeaveTooltipText
      },
      acceptedOccasional: {
        header: 'Accepted Special Absence',
        tooltip: ''
      },
      plannedOccasional: {
        header: 'Planned Special Absence',
        tooltip: ''
      }
    }

    return { headers, showCarryoverInfo }
  }
})
